import { ReactNode } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const useStyles = makeStyles({
  root: {
    alignItems: 'center',
    border: '1px solid var(--bui-fg-disabled)',
    borderRadius: 'var(--bui-radius-1)',
    color: 'var(--bui-fg-secondary)',
    display: 'inline-flex',
    flexShrink: 0,
    height: 32,
    justifyContent: 'center',
    width: 32,
    '& > svg': {
      height: 14,
      width: 14,
    },
  },
});

interface ArtifactIconProps {
  children: ReactNode;
  className?: string;
}

export const ArtifactIcon = ({ children, className }: ArtifactIconProps) => {
  const classes = useStyles();
  return (
    <span className={classNames(classes.root, className)}>{children}</span>
  );
};
